module.exports = __webpack_public_path__ + "09e902df54dca29a203793a6ec8d9fc6.jpg";


//////////////////
// WEBPACK FOOTER
// ../components/images/family-on-elephants.jpg
// module id = 1077
// module chunks = 0